define([], function () {
  "use strict";

  var _exports = {};
  /* Copyright 2026 The MathWorks, Inc. */

  /**
   * Returns true if the given MATLAB source code defines a plain text
   * App Designer class (i.e. a classdef that inherits from matlab.apps.App).
   * @param {string} matlabCode
   * @returns {boolean}
   */
  function isPlainTextAppDesignerClass(matlabCode) {
    if (typeof matlabCode !== 'string') {
      return false;
    }

    // Strip block comments (%{ ... %}) and then line comments/blank lines
    // from the top of the file to find the first real code line.
    let code = matlabCode.replace(/%\{[^]*?%\}/g, '');
    const lines = code.split('\n');
    let firstCodeLine = -1;
    for (let i = 0; i < lines.length; i++) {
      if (!/^\s*(%.*)?$/.test(lines[i])) {
        firstCodeLine = i;
        break;
      }
    }
    if (firstCodeLine === -1) {
      return false;
    }

    // Rejoin from the first code line onward and strip line continuations.
    code = lines.slice(firstCodeLine).join('\n');
    const stripped = code.replace(/\.\.\.[^\n]*\n/g, ' ');
    if (!/^\s*classdef[\s(]/.test(stripped)) {
      return false;
    }
    const headerMatch = stripped.match(/^\s*(classdef\b[^\n]*)/m);
    if (!headerMatch) {
      return false;
    }

    // Strip inline comments.
    const header = headerMatch[1].replace(/%[^\n]*/g, '');

    // Check for a superclass list.
    const ltIndex = header.indexOf('<');
    if (ltIndex === -1) {
      return false;
    }

    // Split on "&", collapse internal whitespace (MATLAB allows spaces around dots
    // in qualified names, e.g. "matlab. apps .App"), then check for exact match.
    const superclasses = header.slice(ltIndex + 1).split('&').map(s => s.trim().replace(/\s+/g, ''));
    return superclasses.some(s => s === 'matlab.apps.App');
  }
  _exports.isPlainTextAppDesignerClass = isPlainTextAppDesignerClass;
  return _exports;
});
//# sourceMappingURL=Isappfile.js.map
